module.exports = __webpack_public_path__ + "ab3c37052397eb96696d2b72a91ed38a.ttf";